import Languages from './Languages';

export default Languages;


// WEBPACK FOOTER //
// ./src/components/Query/Languages/index.ts